import css from '@styled-system/css';
import { Button } from 'affiny-ui/src';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import TextareaAutosize from 'react-textarea-autosize';
import Textarea from 'react-textarea-autosize';
import styled from 'styled-components';
import rem from '../../utils/rem';
import { Box, Flex } from '../primitives';

interface IMessageInput {
  autoFocus?: boolean;
  onClick?: () => void;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isLoading?: boolean;
  onUpdateInputHeight?: (height: number) => void;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  color?: string;
  textAreaRef?: RefObject<TextareaAutosize & HTMLTextAreaElement>;
}

export const MESSAGE_INPUT_HEIGHT = 40;

export const MessageInput = ({
  autoFocus = false,
  onChange,
  onClick,
  onFocus,
  isLoading = false,
  onUpdateInputHeight,
  textAreaRef,
}: IMessageInput) => {
  const { t } = useTranslation();

  return (
    <Flex
      px={['small', 'large']}
      pt={['small', 'medium']}
      pb={['small', 'medium']}
      bg={['light', 'alabaster']}
      borderColor={['gallery', 'gallery']}
      borderWidth={0}
      borderTopWidth={1}
      borderStyle="solid"
      alignItems="center"
      flex="0 0 auto"
    >
      <SInput
        onFocus={onFocus}
        onHeightChange={onUpdateInputHeight}
        placeholder={t('messageInput.placeholder')}
        onChange={onChange}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        minRows={1}
        maxRows={8}
        data-test="message-input"
        inputRef={textAreaRef}
      />
      <Box ml=".5rem">
        <SButton
          size="small"
          data-test="message-input-button"
          icon="send-message-arrow"
          variant="contained"
          color="primary"
          disabled={isLoading}
          onClick={onClick}
        />
      </Box>
    </Flex>
  );
};

const SButton = styled(Button)`
  height: ${rem(40)};
  width: ${rem(40)};

  & > div {
    font-size: ${rem(24)};
    top: 1px;
    left: -1px;
  }
`;

const SInput = styled(Textarea)`
  flex-grow: 1;
  outline: none;
  border: none;
  resize: none;
  box-sizing: border-box;
  margin: 0;
  ${css({
    color: ['primary', 'primary'],
    bg: ['alabaster', 'light'],
    px: ['medium', 'medium'],
    py: ['11px', rem(10)],
    borderRadius: [
      `${MESSAGE_INPUT_HEIGHT / 2}px`,
      rem(MESSAGE_INPUT_HEIGHT / 2),
    ],
    minHeight: [`${MESSAGE_INPUT_HEIGHT}px`, rem(MESSAGE_INPUT_HEIGHT)],
    maxHeight: [`${3 * MESSAGE_INPUT_HEIGHT}px`, 'initial'],
    fontSize: ['inherit', rem(14)],
    lineHeight: ['inherit', rem(19)],
  }) as any}
  &::placeholder {
    font-style: italic;
    ${css({
      color: ['primary', 'primary'],
    }) as any}
  }
`;
